import { type TooltipListProps } from '~/components/component-library/Tooltip/types'

export const TooltipList = ({ caption, children }: TooltipListProps) => (
  <div className="flex max-h-64 max-w-64 flex-col gap-2 overflow-y-auto px-0.5 py-1.5 text-left">
    {caption && <span className="text-secondary">{caption}</span>}
    {children}
  </div>
)
